<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo :titulo="locale[local].screen.beneficios.tituloLabel" />
      <v-divider />
      <template>
        <v-row justify="space-around">
          <v-col
            cols="12"
            sm="8"
            md="6"
          >
            <v-skeleton-loader
              :loading="loadingPeriodos"
              transition="scale-transition"
              height="80"
              :types="{ skeleton: 'list-item' }"
              type="skeleton"
            >
              <v-slide-group show-arrows>
                <v-chip-group active-class="white--text primary ">
                  <v-chip
                    v-for="option in datas"
                    :key="option.descricao"
                    @click="buscaPlanoSaude(option)"
                  >
                    {{ option.descricao }}
                  </v-chip>
                </v-chip-group>
              </v-slide-group>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </template>
      <template v-if="!showError">
        <v-container>
          <v-data-table
            :headers="headers"
            :items="beneficios"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:[`item.vlrMes`]="{ item }">
                {{ "R$ " + formatNumber(item.vlrMes) }}
            </template>
            <template v-slot:[`item.vlrAno`]="{ item }">
                {{ "R$ " + formatNumber(item.vlrAno) }}
            </template>

          </v-data-table>
        </v-container>
      </template>

      <template v-if="showError">
        <v-row justify="space-around">
          <v-col
            cols="12"
            md="6"
            class="py-0"
          >
            <v-card
              class="mx-auto"
              max-width="344"
            >
              <v-card-text>
                <p class="headline text--primary">
                  Erro:
                </p>

                <div class="subtitle-1 text--primary">
                  {{ errorMessage }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-content>
  </v-app>
</template>

<script>
import moment from "moment";
import Service from "@/components/api/Service";
import { formatNumber } from 'cids-cgi/lib/util'
import { locale } from '../locale/locale';

export default {
  data () {
    return {
      service: new Service(),
      showError: false,
      errorMessage: "",
      menu: false,
      modal: false,
      beneficios: [],
      headers: [
        { text: locale[window.local].screen.beneficios.table01.header01, value: 'descricao' },
        { text: locale[window.local].screen.beneficios.table01.header02, value: 'nomeEmpresa' },
        { text: locale[window.local].screen.beneficios.table01.header03, value: 'vlrMes', align: 'end' },
        { text: locale[window.local].screen.beneficios.table01.header04, value: 'vlrAno', align: 'end' },
      ],
      hoje: new Date(),
      datas: [],
      meses: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
      formatNumber: formatNumber,

      //Loadings
      loading: false,
      loadingPeriodos: false,
    };
  },
  created () {
    moment.locale("pt-br");
    this.getMeses()
  },
  methods: {
    replace (val) {
      if (val === 0) {
        return "00:00";
      }
      const [hora, minuto] = val.toString().split(".");

      if (parseInt(hora) === 0) {
        return `00:${minuto}`;
      }

      if (parseInt(minuto) === 0) {
        return `${hora}:00`;
      }

      if (!minuto) {
        return `${hora}:00`;
      }
      return `${hora}:${minuto}`;
    },
    moment: function () {
      return moment();
    },

    async buscaPlanoSaude (option) {
      try {

        var resposta = await this.service.getPlanoSaude(option.mes, option.ano)
        if (resposta.status === 200) {
          if (resposta.data.retorno) {
            if (resposta.data.retorno[0].estatus === "Erro") {
              this.showError = true
              this.setErrorMessage(resposta.data.retorno[0].msgErro)
              throw new Error(resposta.data.retorno[0].msgErro);
            }
          } if (resposta.data.planoSaude.length > 0) {
            this.beneficios = resposta?.data?.planoSaude ?? []
            this.showError = false
          } else {
            this.showError = true
            this.setErrorMessage(locale[window.local].screen.beneficios.error01Label)
          }
        } else {
          throw new Error();
        }
      }
      catch (e) {
        this.loadingPeriodos = false;
        console.log(e);
      }
    },
    getMeses () {
      for (var i = 1; i <= 6; i++) {

        this.hoje.setMonth((this.hoje.getMonth()), -1);

        var stringDate = this.meses[this.hoje.getMonth()] + "/" + this.hoje.getFullYear();
        var thisMonth = (this.hoje.getMonth() + 1)
        var thisYear = this.hoje.getFullYear()
        this.datas.push({
          descricao: stringDate,
          mes: thisMonth,
          ano: thisYear
        });
        //this.hoje.setMonth((this.hoje.getMonth()), -1);
      }
      return this.datas
    },
    setErrorMessage (errorMessage) {
      this.showError = true;
      this.errorMessage = errorMessage;
    },
    cleanErrorMessage () {
      this.showError = false;
      this.errorMessage = "";
    },
  },
};
</script>

<style scoped>
.text-dados-titulo {
  font-size: 1.5em;
  font-weight: bold;
}

.text-dados-sub-titulo {
  font-size: 1.2em;
  font-weight: bold;
}

.text-filters {
  font-size: 0.9em;
  font-weight: bold;
}

.proventos {
  color: green;
}

.descontos {
  color: red;
}

.liquido {
  color: blue;
}

.text-dados {
  font-size: 1.2em;
}
</style>
